import { Component } from '@theme/component';

/** Matches mobile browser background to the final footer while it is visible. */
class FooterBackground extends Component {
  /** @type {IntersectionObserver | undefined} */
  #observer;
  /** @type {AbortController | undefined} */
  #listeners;
  /** @type {MediaQueryList | undefined} */
  #mobile;
  #visible = false;
  #active = false;

  connectedCallback() {
    super.connectedCallback();
    this.#listeners = new AbortController();
    this.#mobile = window.matchMedia('(max-width: 749px)');
    this.#mobile.addEventListener('change', this.#sync, { signal: this.#listeners.signal });
    this.#observer = new IntersectionObserver(([entry]) => {
      this.#visible = entry?.isIntersecting ?? false;
      this.#sync();
    });
    this.#observer.observe(this);
  }

  updatedCallback() {
    super.updatedCallback();
    this.#sync();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#observer?.disconnect();
    this.#listeners?.abort();
    if (this.#active) this.#restore();
    this.#visible = false;
  }

  #sync = () => {
    const active = Boolean(this.#mobile?.matches && this.#visible);
    if (!active) {
      if (this.#active) this.#restore();
      return;
    }

    const background = getComputedStyle(this).getPropertyValue('--color-background').trim();
    if (!background) return;
    document.body.style.setProperty('--footer-browser-background', background);
    document.documentElement.classList.add('footer-edge-visible');
    this.#active = true;
  };

  #restore() {
    document.documentElement.classList.remove('footer-edge-visible');
    document.body.style.removeProperty('--footer-browser-background');
    this.#active = false;
  }
}

if (!customElements.get('footer-background')) {
  customElements.define('footer-background', FooterBackground);
}
